<template>
  <div class="deviceInfo">
    <el-form-item v-if="showType=='invite'" :ref="'list.' + index + '.phone'" :prop="'list.' + index + '.phone'"
      :rules="deviceInfo.rules.telephone" label="">
      <el-input v-model.trim="deviceInfo.phone" placeholder="请输入手机号,必填" size="small" @focus="addDriver(index)">
      </el-input>
    </el-form-item>
    <el-form-item v-if="showType=='invite'&&type===2" :ref="'list.' + index + '.specRole'"
      :prop="'list.' + index + '.specRole'" :rules="deviceInfo.rules.specRole1" label="">
      <el-cascader v-model="deviceInfo.specRole" :props="specRoleDefaultProps" size="small" placeholder="请选择所属专业/角色,必填"
        :options="specRoleList">
      </el-cascader>
    </el-form-item>
    <el-form-item v-if="showType=='add'" :ref="'list.' + index + '.phone'" :prop="'list.' + index + '.phone'"
      :rules="deviceInfo.rules.telephone" label="">
      <el-input v-model.trim="deviceInfo.phone" placeholder="请输入手机号,必填" size="small" @focus="addDriver(index)">
      </el-input>
    </el-form-item>
    <el-form-item v-if="showType=='add'" :ref="'list.' + index + '.name'" :prop="'list.' + index + '.name'"
      :rules="deviceInfo.rules.name1" label="">
      <el-input v-model.trim="deviceInfo.name" placeholder="请输入姓名,必填" maxlength="10" size="small" show-word-limit
        class="userNameStyle" :disabled="deviceInfo.disabledName"></el-input>
    </el-form-item>
    <el-form-item v-if="showType=='add'" :ref="'list.' + index + '.userName'" :prop="'list.' + index + '.userName'"
      :rules="deviceInfo.rules.userName1" label="">
      <el-input v-model.trim="deviceInfo.userName" placeholder="请输入账号,非必填" maxlength="20" style="" size="small"
        show-word-limit class="userNameStyle" :disabled="deviceInfo.disabledUserName"></el-input>
    </el-form-item>
    <el-form-item :ref="'list.' + index + '.neiwaibu'" :prop="'list.' + index + '.neiwaibu'"
      :rules="deviceInfo.rules.neiwaibu1" label="">
      <el-select v-model="deviceInfo.neiwaibu" placeholder="请选择人员类别,必填" clearable size="small" filterable>
        <el-option v-for="item in DEVICE_BRAND" :key="item.item" :label="item.item" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :prop="'list.' + index + '.bumen'" label="">
      <el-input v-model="deviceInfo.bumen" :title="deviceInfo.bumen" clearable placeholder="请选择部门" readonly size="small"
        @focus="changebumen(index)"></el-input>
    </el-form-item>
    <el-form-item v-if="list.length > 1" label="">
      <p style="color:#FF5454" @click="removeComponent">
        删除
      </p>
    </el-form-item>
    <el-dialog v-if="departmentVisible" v-dialogDrag :visible.sync="departmentVisible" :before-close="departmentClose"
      title="部门" width="30%" class="people_class" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="bottom_left">
        <org-tree ref="orgTree" @orgcurrent="currentOrgChangeHandler"></org-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="departmentClose">取 消</el-button>
        <el-button size="small" type="primary" @click="departmentselsetBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import docService from "@/CommonDP/service/doc-service";
import { mapState } from "vuex";
export default {
  components: { orgTree },
  props: {
    index: { default: 0, type: Number },
    list: { type: Array, required: true },
    deviceInfo: { type: Object, required: true },
    type: { default: 0, type: Number } // 1 企业 2项目
  },
  data() {
    return {
      DEVICE_BRAND: [
        {
          item: "内部",
          id: "0"
        },
        {
          item: "外部",
          id: "1"
        }
      ],
      departmentVisible: false,
      currentDepartment: {},
      specRoleList: [],
      specRoleDefaultProps: {
        children: "childList",
        label: "roleName",
        value: "roleId"
      },
      showType: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj
    })
  },
  created() {
    const { showType } = this.$route.query;
    this.showType = showType;
    if (this.type === 2) this.querySpecRoleList();
  },
  methods: {
    async querySpecRoleList() {
      const { prjId } = this.prjInfo;
      const result = await docService.queryRoleList(prjId, this.enterpriseId);
      result.data.map((item) => {
        // 为了保持名称一致 获取的时候好获取
        item.roleName = item.specName;
        item.roleId = item.specId;
      });
      this.specRoleList = result.data;
    },
    removeComponent() {
      this.$emit("removeComponent", this.index);
    },
    addDriver(index) {
      this.$emit("addComponent", index);
    },
    changebumen() {
      this.departmentVisible = true;
    },
    departmentClose() {
      this.departmentVisible = false;
      this.currentDepartment = {};
    },
    departmentselsetBtn() {
      this.departmentVisible = false;
      this.deviceInfo.bumen = this.currentDepartment.fullDeptName;
      this.deviceInfo.bumenid = this.currentDepartment.deptId;
    },
    currentOrgChangeHandler(val) {
      this.currentDepartment = val;
    }
  }
};
</script>
<style  lang="scss">
.people_class {
  .el-dialog__body {
    height: 300px;
  }
}
</style>
<style lang="scss" scoped>
.deviceInfo {
  .el-textarea__inner {
    width: 420px;
  }
  .remove {
    color: #fafafa;
    background: #f56c6c;
    border-color: #f56c6c;
  }
  .el-input__inner {
    width: 246px !important;
  }
  .el-form-item {
    margin-bottom: 15px !important;
    /deep/ .el-form-item__content {
      height: 40px !important;
      .el-input__clear {
        width: 15px;
      }
    }
  }
  .bottom_left {
    height: 100%;
    overflow: auto;
  }
}
</style>
